import React from 'react';

import { BadgeList } from '../components/BadgeList';
import { useBadgeService } from '../services/useBadgeService';

export const BadgeContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const service = useBadgeService();

  if (service.isHide) {
    return null;
  }

  return <BadgeList {...service} />;
};
